import React from 'react';

const BAND_STYLES: Record<string, string> = {
  high: 'bg-green-900/50 text-green-200 border-green-700',
  medium: 'bg-amber-900/50 text-amber-200 border-amber-700',
  low: 'bg-secondary-700 text-secondary-200 border-secondary-600',
  rejected: 'bg-red-900/50 text-red-200 border-red-800',
};

interface ConfidenceBadgeProps {
  band?: string | null;
  score?: number | null;
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ band, score }) => {
  if (!band && score == null) {
    return <span className="text-secondary-500 text-sm">—</span>;
  }

  const key = (band || 'low').toLowerCase();
  const style = BAND_STYLES[key] ?? BAND_STYLES.low;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${style}`}
    >
      {band && <span className="capitalize">{band}</span>}
      {score != null && <span className="opacity-80">({score})</span>}
    </span>
  );
};

export default ConfidenceBadge;
